const devAPI = 'http://127.0.0.1:3010';
const prodAPI = 'https://crm-api.apifdf.com';

export const getAPIDomain = () =>{
    if(window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1"
     ){
        return devAPI;
    }else{
        return prodAPI;
    }
}